import { render, staticRenderFns } from "./organization-cell.vue?vue&type=template&id=b953571c&scoped=true"
import script from "./organization-cell.vue?vue&type=script&lang=js"
export * from "./organization-cell.vue?vue&type=script&lang=js"
import style0 from "./organization-cell.vue?vue&type=style&index=0&id=b953571c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b953571c",
  null
  
)

export default component.exports